import PropTypes from "prop-types";
import React from "react";
import { Button } from "reactstrap";
import "./SimpleButton.scss";
import { imageURl } from "../../libs/env";

const PreviousButton = ({IsonRecorder ,label, ...props }) => {
  return (
    <Button className={IsonRecorder
      ? "btn btn-light text-primary disabled py-1"
      : "btn btn-light text-primary py-1"} {...props}>
      <img src={`${imageURl}/left-arrow.png`} height={"30px"} alt="" />{" "}
      <span className="ms-3">{label}</span>
    </Button>
  );
};

PreviousButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default PreviousButton;
